import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { createContext } from "use-context-selector";
import jwt_decode from "jwt-decode";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { isEmpty, pick } from "lodash";
import { toast } from "react-toastify";
import secureLocalStorage from "react-secure-storage";
import { io } from "socket.io-client";
import i18n from "../i18n";
import { isMobile } from "react-device-detect";
import { withLoader } from "../Utils/constants";
const AuthContext = createContext();
export default AuthContext;
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const navigate = useNavigate();
  const [menuModal, setMenuModal] = useState(false);
  const [sidebarModal, setSidebarModal] = useState(false);

  const [sidebarModalAccount, setSidebarModalAccount] = useState(false);

  const [sokcetId, setSocketId] = useState({});
  const [casinoModal, setCasinoModal] = useState(false);
  const [theme, setTheme] = useState(false);
  const [chatId, setChatId] = useState("");
  const [betCount, setBetCount] = useState(0);
  const [casinoBefore, setCasinoBefore] = useState(false);
  const [betLoader, setBetLoader] = useState(false);
  const [tab, setTab] = useState("in_play");
  const [profileModal, setProfileModal] = useState(false);
  const [parlay, setParlay] = useState(false);
  const [homeTab, setHomeTab] = useState("hot");
  const [sportTab, setSportsTab] = useState("all");
  const [isToggle, setIsToggle] = useState(false);
  const [defaultStakeLimit, setDefaultStakeLimit] = useState([]);
  const [profileData, setProfileData] = useState({});
  const [userCoins, setUserCoins] = useState({});
  const [search, setSearch] = useState(false);
  const [blockList, setBlockList] = useState([]);
  const [oneclickActive, setOneClickActive] = useState(false);
  const [oneClickBid, setOneClickBid] = useState(10);
  const [righSidebar, setRightsideBar] = useState(false);
  const [announcement, setAnnouncement] = useState(false);
  const [messagelist, setMessageList] = useState([]);
  const [showBets, setShowBets] = useState(false);
  const [parlyBet, setParlyBet] = useState([]);
  const [showParlyBet, setShowParlyBet] = useState(false);
  const location = useLocation();
  const [whatsappModal, setWhatsappModal] = useState(false);
  const [showCasino, setShowCasino] = useState(false);
  const [showCasinoUrl, setShowCasinoUrl] = useState("");
  const [logoutShow, setLogoutShow] = useState(false);
  const [lang, setLang] = useState("en");
  const [tv, setTv] = useState({});
  const [refreshAmountLoader, setRefreshAmountLoader] = useState(false);
  const handleRouteChange = async () => {
    let lang = "en";
    const language_dir = localStorage.getItem("language_dir");

    if (!isEmpty(language_dir)) {
      lang = language_dir;
    }
    i18n.changeLanguage(lang);
    setLang(lang);
  };


  const changeLanguage = (type) => {
    localStorage.setItem("language_dir", type);
    i18n.changeLanguage(type);
    setLang(type);
    window.location.reload();
  };
  useEffect(() => {
    handleRouteChange();
  }, []);

  useEffect(() => {
    if (!isEmpty(localStorage.getItem("chatId"))) {
      setChatId(localStorage.getItem("chatId"));
    }
  }, []);

  const tawkMessengerRef = useRef(null);
const [tawkLoaded, setTawkLoaded] = useState(false);

const handleOpenChat = useCallback(() => {
  if (!tawkLoaded || !tawkMessengerRef.current) return;
  tawkMessengerRef.current.showWidget?.();
  requestAnimationFrame(() => {
    tawkMessengerRef.current?.maximize?.();
  });
}, [tawkLoaded]);

  const updateParly = (value) => {
    localStorage.setItem("parly", value);
    setParlay(value);
  };
  useEffect(() => {
    if (localStorage.getItem("parly") == "true") {
      setParlay(true);
    } else {
      setParlay(false);
    }
  }, []);

  useEffect(() => {
    setMenuModal(false);
    setSidebarModal(false);
    setRightsideBar(false);
    setAnnouncement(false);
    setProfileModal(false);
    setWhatsappModal(false);
    setShowCasino(false);
    setCasinoBefore(false);
    setSidebarModalAccount(false)
    setCasinoModal(false);
    setSearch(false);
    setTv({});
    setShowCasinoUrl("");
    setShowBets(false);
  }, [location]);

  useEffect(() => {
    if (secureLocalStorage.getItem("parlyBet")?.length > 0) {
      setParlyBet(secureLocalStorage.getItem("parlyBet"));
    }
  }, []);

  useEffect(() => {
    if (
      location?.pathname?.split("/")[1] !== "match-details" &&
      !isEmpty(sokcetId)
    ) {
      sokcetId.disconnect();
      setSocketId({});
    }
  }, [location]);

  const amounutRefresh = async () => {
    setRefreshAmountLoader(true);
    const { status, data } = await apiGet(apiPath.refreshAmount);
    if (status === 200) {
      console.log();
      if (data.success) {
        setUserCoins({
          exposure: data?.results?.exposure,
          totalCoins: data?.results?.totalCoins,
        });
      }
    }
    setRefreshAmountLoader(false);
  };

  let loginUser = async (body) => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    body.website = hostname || "SABAEXCH";
    const { status, data } = await apiPost(
      apiPath.loginUser,
      pick(body, ["username", "password", "uniqueId", "website"]),
    );
    if (status === 200) {
      if (data.success) {
        setChatId(data.results.platformType);
        localStorage.setItem("chatId", data.results.platformType);
        localStorage.setItem("token", data.results.token);
        localStorage.setItem("refresh_token", data.results.refresh_token);
        setUser(jwt_decode(data.results.token));

        // if (data?.results?.isPasswordReset) {
        //   navigate("/reset-password");
        // } else {
        navigate("/");
        // }
      } else {
        toast.error(data?.message);
      }
    } else {
      toast.error(data?.message);
    }
  };

  const getProfileData = async () => {
    const data = await apiGet(apiPath.userProfile);

    if (data?.data?.success) {
      setOneClickBid(data?.data?.results?.defaultOneClickBetStake);
      setOneClickActive(data?.data?.results?.isOneClickBetStake);

      setDefaultStakeLimit(data?.data?.results?.defaultStakeLimit);
      if (data?.data?.results?.marketBlockList?.length > 0) {
        setBlockList(
          data?.data?.results?.marketBlockList?.map((res) => {
            return res?.eventId;
          }),
        );
      }
      setProfileData(data?.data?.results);
      setUserCoins({
        exposure: data?.data?.results?.exposure,
        totalCoins: data?.data?.results?.totalCoins,
      });
    }
  };
  const messageList = async () => {
    const { status, data: response_users } = await apiGet(apiPath.messageList);
    if (status === 200) {
      if (response_users.success) {
        setMessageList(response_users.results);
      }
    }
  };

  useEffect(() => {
    let data = localStorage.getItem("token")
      ? jwt_decode(localStorage.getItem("token"))
      : "";
    setUser(data);
  }, []);

  useEffect(() => {
    if (!isEmpty(user)) {
      getProfileData();
      messageList();

      // if (user?.user?.isPasswordReset) {
      //   navigate("/reset-password");
      // }
    }
  }, [user]);

  let logoutUser = () => {
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    setLogoutShow(false);
    setMenuModal(false);
    setSidebarModal(false);
    setRightsideBar(false);
  };

  useEffect(() => {
    if (sidebarModal) {
      setRightsideBar(false);
    }
    if (righSidebar) {
      setSidebarModal(false);
    }
  }, [righSidebar, sidebarModal]);

  // Socket start
  const [socket, setSocket] = useState(null);
  const [score, setScore] = useState([]);
  const [cricketScore, setCricketScore] = useState([]);
  const [isSocketActive, setIsSocketActive] = useState(true);

  // ✅ Extract pathname once for reusability
  const pathname = location?.pathname?.split("/")[1];
  const isSportsPage = [
    "sports",
    "match-detail",
    "sports-velki",
    "match-detail-velki",
    "sports-sky",
  ].includes(pathname);

  // ✅ Initialize socket connection
  const initializeSocket = useCallback(() => {
    if (!isSocketActive || !isSportsPage) return;

    // Disconnect previous socket before creating a new one
    if (socket) {
      socket.disconnect();
    }

    const randomId = user?.user?._id || 112233;
    const url = isEmpty(user)
      ? `${process.env.REACT_APP_API_SCORE_URL}?user_id=${randomId}`
      : `${process.env.REACT_APP_API_SCORE_URL}?token=${randomId}&userType=front`;

    const newSocket = io(url, {
      transports: ["websocket"],
      forceNew: true,
    });

    // Listen to score updates
    newSocket.on("scoreAll", setScore);
    newSocket.on("scoreCricketAll", setCricketScore);

    // Auto-refresh socket if disconnected
    newSocket.on("disconnect", () => {
      setIsSocketActive(true);
    });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, [isSocketActive, isSportsPage, user]);

  // ✅ Re-initialize socket when page or refresh status changes
  useEffect(() => {
    initializeSocket();
  }, [initializeSocket]);

  // ✅ Handle visibility change (pause/resume socket)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!isSportsPage) return;

      if (document.hidden) {
        setIsSocketActive(false);
        if (socket) socket.disconnect();
      } else {
        setIsSocketActive(true);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isSportsPage, socket]);

  // ✅ Disconnect socket when leaving sports pages
  useEffect(() => {
    if (!isSportsPage && socket) {
      socket.disconnect();
      setSocket(null);
    } else if (isSportsPage && (!socket || !socket.connected)) {
      setIsSocketActive(true);
    }
  }, [isSportsPage, socket]);
  // Socket end

  const launchCasino = async (request) => {
    await withLoader(setBetLoader, async () => {
      if (request?.platForm || request?.gameType || request?.casinoType) {
        const { status, data: response_users1 } = await apiPost(
          apiPath.casinoAmountAdd,
          { amount: 0, platForm: request?.platForm },
        );

        if (response_users1.success) {
          const { status, data: response_users } = await apiPost(
            request?.platForm && request?.gameType && request?.casinoType
              ? apiPath.doLoginAndLaunchGame
              : apiPath.casinoWalletLogin,
            request?.platForm && request?.gameType && request?.casinoType
              ? request?.table
                ? {
                    userId: response_users1?.data?.aeCasinoUserId,
                    platForm: request?.platForm == "1" ? "" : request?.platForm,
                    gameType: request?.gameType,
                    gameCode: request?.casinoType,
                    gameTableId: request?.table,
                    isLaunchGameTable: true,
                  }
                : {
                    userId: response_users1?.data?.aeCasinoUserId,
                    platForm: request?.platForm == "1" ? "" : request?.platForm,
                    gameType: request?.gameType,
                    gameCode: request?.casinoType,
                  }
              : {
                  userId: response_users1?.data?.aeCasinoUserId,
                  gameType: request?.gameType,
                  platForm: request?.platForm == "1" ? "" : request?.platForm,
                },
          );

          if (response_users.status) {
            if (response_users.data.status === "0000") {
              if (isMobile) {
                setShowCasino(true);
                setShowCasinoUrl(response_users.data.url);
              } else {
                window.location.href = response_users.data.url;
              }
            } else {
              toast.error(response_users?.data?.desc);
            }
          } else {
            toast.error(response_users?.message);
          }
        } else {
          toast.error(response_users1?.message);
        }
      } else {
        toast.error("comming soon");
      }
    });
  };
  const [socialIcon, setSocialIcon] = useState({});

  const getData = async () => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    const { data } = await apiGet(apiPath?.getSetting, {
      website: hostname,
    });
    if (data?.success) {
      setSocialIcon(data?.results);
    }
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      getData();
    }
  }, [user]);

  let contextData = {
    user,
    setUser,
    menuModal,
    setMenuModal,
    sidebarModal,
    setSidebarModal,
    loginUser,
    sokcetId,
    setSocketId,
    logoutUser,
    blockList,
    userCoins,
    profileData,
    defaultStakeLimit,
    amounutRefresh,
    oneClickBid,
    setOneClickBid,
    oneclickActive,
    setOneClickActive,
    righSidebar,
    setRightsideBar,
    announcement,
    setAnnouncement,
    messagelist,
    parlyBet,
    setParlyBet,
    showParlyBet,
    setShowParlyBet,
    launchCasino,
    whatsappModal,
    setWhatsappModal,
    tab,
    setTab,
    scoreAll: [...score, ...cricketScore],
    getProfileData,
    chatId,
    setChatId,
    isToggle,
    setIsToggle,
    sportTab,
    setSportsTab,
    homeTab,
    setHomeTab,
    parlay,
    setParlay: updateParly,
    theme,
    setTheme,
    showBets,
    setShowBets,
    showCasino,
    setShowCasino,
    logoutShow,
    setLogoutShow,
    changeLanguage,
    lang,
    casinoBefore,
    setCasinoBefore,
    showCasinoUrl,
    refreshAmountLoader,
    search,
    setSearch,
    tv,
    setTv,
    casinoModal,
    setCasinoModal,
    profileModal,
    setProfileModal,
    betLoader,
    setBetLoader,
    betCount,
    setBetCount,
    socialIcon,
    // bannerData,
    sidebarModalAccount,
    setSidebarModalAccount,tawkMessengerRef ,setTawkLoaded    
  };
  return (
    <AuthContext.Provider value={contextData}>{children}</AuthContext.Provider>
  );
};
